import { useDropzone } from 'react-dropzone';
import PropTypes from 'prop-types';

const ONE_HUNDRED_MB = 104857600;

const DropzoneInput = incomingProps => {
  const props = {
    ...{
      component: null,
      multiple: false,
      name: '',
      onChange: () => {},
      maxSize: ONE_HUNDRED_MB,
      onDropRejected: () => {},
      onDropAccepted: () => {},
    },
    ...incomingProps,
  };
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: props.accept,
    multiple: props.multiple,
    maxSize: props.maxSize,
    onDrop: filesToUpload => props.onChange(filesToUpload),
    onDropAccepted: props.onDropAccepted,
    onDropRejected: props.onDropRejected,
  });

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <div
      {...getRootProps()}
      style={{ position: 'relative', display: 'inline-block', padding: '6px' }}
    >
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <input {...getInputProps({ name: props.name })} />
      <div>{props.component}</div>
      {isDragActive && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            border: '2px dashed #2196f3',
            borderRadius: '4px',
            backgroundColor: 'rgba(33, 150, 243, 0.15)',
            pointerEvents: 'none',
          }}
        />
      )}
    </div>
  );
};

DropzoneInput.propTypes = {
  // react-dropzone v14 `accept` map: MIME type -> list of file extensions.
  // See acceptedFileTypes.js for the shared definitions.
  accept: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
  component: PropTypes.node,
  multiple: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
  maxSize: PropTypes.number,
  onDropRejected: PropTypes.func,
  onDropAccepted: PropTypes.func,
};

export default DropzoneInput;
